module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "buyList"
  }, _vm._l((_vm.buyList), function(item, index) {
    return (index > _vm.buyListIndex) ? _c('li', {
      key: index
    }, [_c('span', {
      attrs: {
        "data-text": item.nick
      }
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/buy.png'
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/' + item.shop_num.toString().substr(0, 1) + '.png'
      }
    }), _vm._v(" "), (item.shop_num > 9) ? _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/' + item.shop_num.toString().substr(1, 1) + '.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/Piece.png'
      }
    })])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d64522"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/buyList.vue
// module id = 347
// module chunks = 0